/**
 * @module  color-measure/is-white
 */

var isDark = require('./is-dark');

module.exports = function (color) {
	return !isDark(color);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/color-measure/is-light.js
// module id = B9PQ
// module chunks = 0